import { RequestStatus } from 'clickNgo/configs/service/common'

import { IAssortmentState } from './models/IAssortmentState'

export const initialState: IAssortmentState = {
  editingGroupId: null,
  categories: {
    originalData: [],
    data: [],
    status: RequestStatus.NONE,
    message: '',
  },
  groups: {
    originalData: [],
    data: [],
    status: RequestStatus.NONE,
    message: '',
  },
  items: {
    originalData: [],
    data: [],
    status: RequestStatus.NONE,
    message: '',
  },
  isCollapsed: false,
  selectedCategory: null,
}
